import React, { useEffect, useState } from "react";
import SelectItems, { OptionsType } from "../../common/SelectItems";
import SelectRegions, { OptionsRegionsType } from "../../common/SelectRegions";
import SelectProvice, {
  OptionsProvinceType,
} from "../../common/SelectProvince";
import SelectDistricts, {
  OptionsDistrictType,
} from "../../common/SelectDistricts";
import SelectSubDistrict, {
  OptionsSubDistrictType,
} from "../../common/SelectSubDistrict";
import CalendarDatePicker from "./CalendarDatePicker";
import SelectSatellite from "../../common/SelectSatellite";
import SelectFileItems from "../../common/SelectFileItems";
import moment from "moment-timezone";
import {
  DashboardAPI,
  DashBoardParamsType,
} from "../../../api/dashboard/Dashboard";
import { DashBoardResponseType } from "./DashBoard";

export interface FilterType {
  startDate: any;
  endDate: any;
  satellite: string;
  countryType?: OptionsType;
  dateType?: 1 | 2;
  fileName?: string;
  provinceGroup?: OptionsType;
  region?: OptionsRegionsType;
  province?: FilterProvinceType[];
  district?: OptionsDistrictType;
  subdistrict?: OptionsSubDistrictType;
}

export interface FilterProvinceType {
  ProvinceCode: string;
  ProvinceName: string;
  RegionCode: string;
  Group17Provinces: number;
}

interface FilterComponentPropType {
  onFilterChanged: (value: FilterType | undefined) => void;
  filters?: FilterType;
  positionClass: string;
}
function FilterComponent({
  onFilterChanged,
  filters,
  positionClass,
}: FilterComponentPropType) {
  const [isInit, setIsInit] = useState(true);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [selectDateType, setSelectDateType] = useState<1 | 2>(1);
  const [selectSatellite, setSelectSatellite] = useState<string>("");
  const [selectCountryGroup, setSelectCountryGroup] = useState<
    OptionsType | undefined
  >();
  const [selectFiles, setSelectFiles] = useState<string>("");
  const [selectCountryType, setSelectCountryType] = useState<OptionsType>();
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [fileList, setFileList] = useState<OptionsType[]>([]);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [isDisableFilterGroup, setIsDisableFilterGroup] = useState({
    provinceGroup: false,
    region: false,
    province: false,
    district: true,
    subdistrict: true,
  });
  const [isDisableButton, setIsDisableButton] = useState(true);
  const [selectRegions, setSelectRegions] = useState<
    OptionsRegionsType | undefined
  >();
  const [selectProvice, setSelectProvice] = useState<
    OptionsProvinceType[] | undefined
  >();
  const [selectDistrict, setSelectDistrict] = useState<
    OptionsDistrictType | undefined
  >();
  const [selectSubDistrict, setSelectSubDistrict] = useState<
    OptionsSubDistrictType | undefined
  >();

  const country = [
    { id: 1, value: "ประเทศไทย" },
    { id: 2, value: "อาเซียน" },
  ];
  const countryGroup = [
    { id: 1, value: "ประเทศไทย" },
    { id: 2, value: "17 จังหวัดภาคเหนือ" },
  ];
  const handleOpenFilter = (value: boolean) => {
    setIsOpenFilter(value);
  };
  const handleSelectDate = (start: Date, end: Date | null) => {
    setStartDate(start);
    setEndDate(end);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectSatellite = (satellite: string) => {
    setSelectSatellite(satellite);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectCountryType = (countryType: OptionsType) => {
    let filter = isDisableFilterGroup;
    if (countryType?.id === 1) {
      filter.provinceGroup = false;
      filter.region = false;
      filter.province = false;
      setIsDisableFilterGroup(filter);
    } else {
      filter.provinceGroup = true;
      filter.region = true;
      filter.province = true;
      setIsDisableFilterGroup(filter);
    }
    setSelectCountryType(countryType);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectFileName = (files: string) => {
    setSelectFiles(files);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectRegions = (regions: OptionsRegionsType) => {
    setSelectRegions(regions);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectProvince = (province: OptionsProvinceType[]) => {
    let filter = isDisableFilterGroup;
    if (province?.length > 1) {
      filter.district = true;
    } else if (province && province?.length === 1) {
      if (province[0]?.ProvinceCode === "0") {
        filter.district = true;
      } else {
        filter.district = false;
      }
    }
    setIsDisableFilterGroup(filter);
    setSelectProvice(province);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectDistrict = (district: OptionsDistrictType) => {
    let filter = isDisableFilterGroup;
    if (district?.DistrictCode !== "0") {
      filter.subdistrict = false;
    } else {
      filter.subdistrict = true;
    }
    setIsDisableFilterGroup(filter);
    setSelectDistrict(district);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectSubDistrict = (subdistrict: OptionsSubDistrictType) => {
    setSelectSubDistrict(subdistrict);
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleSelectCountryGroup = (countryGroup: OptionsType) => {
    setSelectCountryGroup(countryGroup);
    if (countryGroup?.id === 1) {
      let filter = isDisableFilterGroup;
      filter.region = false;
      filter.province = false;
      setIsDisableFilterGroup(filter);
    } else {
      let filter = isDisableFilterGroup;
      filter.region = true;
      filter.province = true;
      setIsDisableFilterGroup(filter);
    }
    if (isDisableButton && !isInit) {
      setIsDisableButton(false);
    }
  };
  const handleResetData = () => {
    let payload: FilterType = {
      satellite: "Suomi NPP",
      startDate: startDate ? startDate : new Date(),
      endDate: endDate ? endDate : null,
    };
    getFilterFileName(payload);
    onFilterChanged(undefined);
    setIsOpenFilter(false);
    setSelectDateType(1);
    setStartDate(new Date());
    setEndDate(null);
    setSelectSatellite("Suomi NPP");
    setSelectCountryType(undefined);
    setSelectFiles("");
    setIsDisableButton(true);
  };
  const getFilterFileName = async (params: FilterType | undefined) => {
    try {
      let payload: DashBoardParamsType = {};
      if (params === undefined) {
        let startOfDay = new Date().setHours(0, 0, 0, 0);
        let endOfDay = new Date().setHours(23, 59, 59, 999);
        let startDate = moment(startOfDay).add(7, "hours").unix();
        let endDate = moment(endOfDay).add(7, "hours").unix();

        payload = {
          instrument: "VIIRS",
          satellite: "Suomi NPP",
          groupby: "file_name",
          limit: 10000,
          timestamp: `${startDate}/${endDate}`,
        };
      } else if (params) {
        payload = {
          groupby: "file_name",
          limit: 10000,
        };
        if (params.startDate && params.endDate === null) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.startDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.startDate && params.endDate) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.endDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.satellite === "VIIRS" || params.satellite === "MODIS") {
          payload.instrument = params.satellite;
        }
        if (
          params.satellite === "Suomi NPP" ||
          params.satellite === "NOAA-20"
        ) {
          payload.instrument = "VIIRS";
          payload.satellite = params.satellite;
        }
      }
      const data = (await DashboardAPI(payload)) as DashBoardResponseType;
      if (data) {
        let prepare = data.items.map((item, index: number) => ({
          id: index,
          value: item.file_name,
        }));

        setFileList(prepare);
        setSelectFiles("");
      }
    } catch (error) {
      console.log("error");
    }
  };
  const handleFilterChange = () => {
    let payload: FilterType = {
      startDate: startDate,
      endDate: endDate,
      satellite: selectSatellite,
      dateType: selectDateType,
      countryType: selectCountryType,
      fileName: selectFiles,
      provinceGroup: selectCountryGroup,
      region: selectRegions,
      province: selectProvice,
      district: selectDistrict,
      subdistrict: selectSubDistrict,
    };
    setIsOpenFilter(false);
    onFilterChanged(payload);
  };
  useEffect(() => {
    setTimeout(() => {
      setIsInit(false);
    }, 2000);
  }, []);
  useEffect(() => {
    setSelectCountryGroup({ id: 1, value: "ประเทศไทย" });
  }, [selectCountryType]);
  useEffect(() => {
    setSelectRegions({
      RegionCode: "0",
      RegionName: "ทั้งหมด",
    });
  }, [selectCountryType]);
  useEffect(() => {
    setSelectRegions({
      RegionCode: "0",
      RegionName: "ทั้งหมด",
    });
  }, [selectCountryGroup]);
  useEffect(() => {
    setSelectProvice([]);
  }, [selectRegions]);
  useEffect(() => {
    if (selectProvice) {
      if (selectProvice.length === 1) {
        setSelectDistrict(undefined);
      } else if (selectProvice.length >= 2) {
        setSelectDistrict({
          DistrictCode: "0",
          DistrictName: "ทั้งหมด",
          ProvinceCode: "0",
        });
      }
    }
  }, [selectProvice]);
  useEffect(() => {
    setSelectSubDistrict(undefined);
  }, [selectDistrict]);
  useEffect(() => {
    setStartDate(filters?.startDate ?? new Date());
    setEndDate(filters?.endDate ?? null);
    setSelectDateType(filters?.dateType ?? 1);
    setSelectSatellite(filters?.satellite ?? "");
    setSelectCountryType(filters?.countryType);
    setSelectCountryGroup(filters?.provinceGroup);
    setSelectProvice(filters?.province);
    setSelectDistrict(filters?.district);
    setSelectSubDistrict(filters?.subdistrict);
    setSelectFiles(filters?.fileName ?? "");
  }, [filters]);

  useEffect(() => {
    let payload: any = {
      startDate: startDate,
      endDate: endDate,
      satellite: selectSatellite,
    };
    getFilterFileName(payload);
  }, [startDate, endDate, selectSatellite]);

  return (
    <div className="relative">
      <div
        className="h-10 z-50 flex gap-2 border-[1px] bg-primary-contrast border-gray-2 rounded-xl p-2 items-center cursor-pointer"
        onClick={() => handleOpenFilter(!isOpenFilter)}
      >
        <img alt="filter-icon" src="icons/filter.png" width={16} height={16} />
        <p className="text-sm text-text-primary">ตัวกรอง</p>
      </div>
      {isOpenFilter && (
        <>
          <div className="w-screen h-screen bg-text-primary bg-opacity-80 z-10 fixed top-0 left-0" />
          <div
            className={`absolute mt-2 w-auto h-[calc(100vh_-_130px)] ${positionClass}  inline-flex flex-col gap-8 px-6 pt-6 pb-10 rounded-3xl bg-primary-contrast z-10 shadow-z8`}
          >
            <div className="flex flex-col gap-6 w-full h-[92%] ">
              <div className="flex justify-between">
                <p className="text-sm font-normal text-text-primary self-center">
                  เลือกวันที่ต้องการ
                </p>
                <div
                  className="self-end cursor-pointer"
                  onClick={() => handleOpenFilter(false)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.3007 5.70973C17.9107 5.31973 17.2807 5.31973 16.8907 5.70973L12.0007 10.5897L7.1107 5.69973C6.7207 5.30973 6.0907 5.30973 5.7007 5.69973C5.3107 6.08973 5.3107 6.71973 5.7007 7.10973L10.5907 11.9997L5.7007 16.8897C5.3107 17.2797 5.3107 17.9097 5.7007 18.2997C6.0907 18.6897 6.7207 18.6897 7.1107 18.2997L12.0007 13.4097L16.8907 18.2997C17.2807 18.6897 17.9107 18.6897 18.3007 18.2997C18.6907 17.9097 18.6907 17.2797 18.3007 16.8897L13.4107 11.9997L18.3007 7.10973C18.6807 6.72973 18.6807 6.08973 18.3007 5.70973Z"
                      fill="#8E8E8E"
                    />
                  </svg>
                </div>
              </div>
              <div className="flex flex-col gap-6 w-full h-full overflow-y-scroll">
                <div className="flex flex-col gap-2">
                  <CalendarDatePicker
                    dateType={selectDateType}
                    onSelectDate={handleSelectDate}
                    onSelectDateType={setSelectDateType}
                    start={startDate}
                    end={endDate}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">
                    ดาวเทียม
                  </p>
                  <SelectSatellite
                    onSelected={handleSelectSatellite}
                    satellite={selectSatellite}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">
                    ประเทศ
                  </p>
                  <SelectItems
                    options={country}
                    selecteValue={selectCountryType}
                    onSelect={handleSelectCountryType}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">
                    ไฟล์ข้อมูล
                  </p>
                  <SelectFileItems
                    selectFile={selectFiles}
                    files={fileList}
                    onSelectFile={handleSelectFileName}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">
                    กลุ่มจังหวัด
                  </p>
                  <SelectItems
                    selecteValue={selectCountryGroup}
                    options={countryGroup}
                    onSelect={handleSelectCountryGroup}
                    isDisable={isDisableFilterGroup.provinceGroup}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">
                    ภูมิภาค
                  </p>
                  <SelectRegions
                    selectRegion={selectRegions}
                    onSelect={handleSelectRegions}
                    hasAll={true}
                    disable={isDisableFilterGroup.region}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">
                    จังหวัด
                  </p>
                  <SelectProvice
                    selectProvince={selectProvice}
                    regions={selectRegions}
                    provinceGroup={selectCountryGroup}
                    disable={isDisableFilterGroup.province}
                    onSelect={handleSelectProvince}
                    hasAll={true}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">อำเภอ</p>
                  <SelectDistricts
                    onSelect={handleSelectDistrict}
                    selectDistrict={selectDistrict}
                    province={selectProvice && selectProvice[0]}
                    hasAll={true}
                    disable={isDisableFilterGroup.district}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <p className="text-text-primary text-sm font-normal">ตำบล</p>
                  <SelectSubDistrict
                    selectSubDistrict={selectSubDistrict}
                    onSelect={handleSelectSubDistrict}
                    district={selectDistrict}
                    hasAll={true}
                    disable={isDisableFilterGroup.subdistrict}
                  />
                </div>
              </div>
            </div>
            <div className="flex gap-2 self-center">
              <button
                disabled={isDisableButton}
                onClick={() => handleResetData()}
                className="text-text-primary px-10 h-10 py-2 bg-primary-contrast border-[1px] border-gray-5 rounded-xl text-base font-normal disabled:border-text-disabled disabled:text-text-disabled"
              >
                ล้าง
              </button>
              <button
                disabled={isDisableButton}
                onClick={() => handleFilterChange()}
                className="px-10 py-2 bg-primary-main h-10 disabled:bg-gray-1 disabled:text-text-disabled rounded-xl text-primary-contrast text-base font-normal"
              >
                แสดง
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default FilterComponent;
